<template>
  <Popover position="is-bottom-left" class="m-l-10 is-narrow" :delay="500">
    <template #trigger>
      <ButtonView
        class="button is-inverted language-button"
        type="is-primary "
        :data-e2e="AuthCypressAttribute.signup.buttons.OPEN_LANGUAGE_DROPDOWN"
      >
        <span>{{ value.abr }}</span>

        <i class="icon is-size-6 cls cls-caret-down"></i>
      </ButtonView>
    </template>
    <template #content>
      <LanguageDropDownItem
        v-for="language in localeValues"
        :option="language"
        :key="language.key"
        @on-language-click="setLanguage"
        :data-e2e="AuthCypressAttribute.signup.buttons.LANGUAGE_DROPDOWN_ITEM"
      />
    </template>
  </Popover>
</template>

<script>
import Popover from '@/modules/core/ui/components/Popover.vue';
import Locale from '@/modules/user/Enum/Locale';
import { EstateType } from '@/modules/estate/enums/EstateType';
import LanguageDropDownItem from '@/modules/auth/components/presentational/LanguageDropdownItem.vue';
import Enum from '@/modules/core/app/helpers/Enum';
import NumeralService from '@/modules/core/app/services/NumeralService';
import Lang from '/@/modules/core/app/services/Lang';
import { AuthCypressAttribute } from '@/modules/auth/constants/AuthCypressAttribute';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'LanguagePopoverSelect',
  emits: ['on-lang-click'],
  components: { ButtonView, LanguageDropDownItem, Popover },
  props: {
    lang: {
      type: Enum
    }
  },
  static: {
    localeValues: Locale.getAllowedLocales(),
    EstateType,
    AuthCypressAttribute
  },
  data() {
    return {
      value: Locale.ENGLISH
    };
  },
  methods: {
    async setLanguage(value) {
      this.value = value;
      await Lang.resetI18n(value.key);
      NumeralService.load(value.key);
      this.$emit('on-lang-click', value.key);
    },
    preSetLang() {
      if (this.lang) {
        this.value = this.lang;
        return;
      }

      this.value = Locale.getByKey(Lang.locale) ?? null;
    }
  },
  mounted() {
    this.preSetLang();
  }
};
</script>

<style scoped>
:deep(.dropdown-menu) {
  min-width: unset !important;
}
</style>
